/* Header 行为。抽屉走 EB.overlay 统一浮层管理，不自己锁滚动。 */
(function () {
  'use strict';
  if (customElements.get('eb-header')) return;

  var OPEN_DELAY = 90;
  var CLOSE_DELAY = 160;

  class EbHeader extends HTMLElement {
    connectedCallback() {
      this.initSticky();
      this.initMega();
      this.initDrawer();
    }

    initSticky() {
      if (!this.classList.contains('eb-hd--sticky')) return;
      var self = this;
      var last = Math.max(window.scrollY || 0, 0);
      var ticking = false;
      var DELTA = 4;

      /* 抽屉或超级菜单开着时表头钉住不动 —— 菜单挂在表头上，表头一走菜单跟着走 */
      function pinned() {
        if (self.classList.contains('is-mega-open')) return true;
        return !!(window.EB && window.EB.overlay && window.EB.overlay.active());
      }

      function update() {
        var y = Math.max(window.scrollY || 0, 0);
        var delta = y - last;

        self.classList.toggle('is-stuck', y > 12);

        /* 第一屏之内一直显示；滑过第一屏之后才开始「下滑收起 / 上滑露出」。
           DELTA 是手抖阈值，惯性滚动的零点几像素不该翻来覆去地收放。 */
        if (pinned() || y <= window.innerHeight) {
          self.classList.remove('is-hidden');
        } else if (delta > DELTA) {
          self.classList.add('is-hidden');
        } else if (delta < -DELTA) {
          self.classList.remove('is-hidden');
        }

        last = y;
        ticking = false;
      }

      update();
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }, { passive: true });

      /* 浮层一开就把表头放回来：浮层期间页面不滚，等下一次 scroll 才纠正就晚了 */
      document.addEventListener('eb:overlay:open', function () {
        self.classList.remove('is-hidden');
      });
      /* 滚动锁解开时 EB 会把位置还原回去（eb-core: unlockScroll），
         那一跳是「还原」不是「用户在下滑」，重新对齐基准，别当成收起信号 */
      document.addEventListener('eb:overlay:close', function () {
        last = Math.max(window.scrollY || 0, 0);
      });
    }

    initMega() {
      var self = this;
      var items = this.querySelectorAll('[data-eb-nav-item]');
      var timer = null;

      function open(item) {
        clearTimeout(timer);
        items.forEach(function (i) { if (i !== item) close(i); });
        var mega = item.querySelector('[data-eb-mega]');
        if (mega) mega.hidden = false;
        window.requestAnimationFrame(function () {
          item.classList.add('is-open');
          self.classList.add('is-mega-open');
        });
        var t = item.querySelector('[data-eb-nav-trigger]');
        if (t) t.setAttribute('aria-expanded', 'true');
      }

      function close(item) {
        item.classList.remove('is-open');
        var t = item.querySelector('[data-eb-nav-trigger]');
        if (t) t.setAttribute('aria-expanded', 'false');
        var mega = item.querySelector('[data-eb-mega]');
        if (mega) {
          window.setTimeout(function () {
            if (!item.classList.contains('is-open')) mega.hidden = true;
          }, 380);
        }
        if (!self.querySelector('[data-eb-nav-item].is-open')) self.classList.remove('is-mega-open');
      }

      items.forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          if (!window.EB || !window.EB.isDesktop()) return;
          clearTimeout(timer);
          timer = window.setTimeout(function () { open(item); }, OPEN_DELAY);
        });
        item.addEventListener('mouseleave', function () {
          clearTimeout(timer);
          timer = window.setTimeout(function () { close(item); }, CLOSE_DELAY);
        });
        var trigger = item.querySelector('[data-eb-nav-trigger]');
        if (trigger) {
          trigger.addEventListener('click', function () {
            if (item.classList.contains('is-open')) close(item); else open(item);
          });
        }
        item.addEventListener('focusout', function (e) {
          if (!item.contains(e.relatedTarget)) close(item);
        });
      });

      this.addEventListener('mouseleave', function () {
        clearTimeout(timer);
        timer = window.setTimeout(function () { items.forEach(close); }, CLOSE_DELAY);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') items.forEach(close);
      });
    }

    initDrawer() {
      var drawer = this.querySelector('[data-eb-drawer]');
      if (!drawer) return;
      var opener = this.querySelector('[data-eb-drawer-open]');
      var release = null;

      window.EB.overlay.register('header-drawer', {
        scrim: false,
        onOpen: function () {
          drawer.classList.add('is-open');
          drawer.setAttribute('aria-hidden', 'false');
          if (opener) opener.setAttribute('aria-expanded', 'true');
          release = window.EB.trapFocus(drawer, drawer.querySelector('[data-eb-drawer-close]'));
        },
        onClose: function () {
          drawer.classList.remove('is-open');
          drawer.setAttribute('aria-hidden', 'true');
          if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
          if (release) { release(); release = null; }
        }
      });

      if (opener) opener.addEventListener('click', function () { window.EB.overlay.open('header-drawer'); });

      drawer.addEventListener('click', function (e) {
        if (e.target.closest('[data-eb-drawer-close]')) {
          window.EB.overlay.close('header-drawer');
          return;
        }
        var btn = e.target.closest('[data-eb-acc-btn]');
        if (!btn) return;
        var acc = btn.closest('[data-eb-acc]');
        var open = !acc.classList.contains('is-open');
        // 一次只开一个，抽屉不会被撑得太长
        drawer.querySelectorAll('[data-eb-acc]').forEach(function (a) {
          a.classList.remove('is-open');
          var b = a.querySelector('[data-eb-acc-btn]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (open) {
          acc.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });

      window.EB.onBreakpoint(function () {
        if (window.EB.isDesktop() && drawer.classList.contains('is-open')) {
          window.EB.overlay.close('header-drawer');
        }
      });
    }
  }

  customElements.define('eb-header', EbHeader);
})();
